import { IDailyForcaWeather, IGResponse } from '@common/models';
import IForecast from '@common/models/CMS/Weather';
import { getFilePath } from '@config/appConfig';
import { WEATHER, useApolloQuery } from '@service/graphql';
import { formatToDate } from '@utilize/Format';
import { FC } from 'react';
import { getSweatIcon } from './WeatherRecent';

interface IWeatherForecastProps {
    dataSource: IDailyForcaWeather;
    loadOf?: 'foreca' | 'mahan';
}

export const WeatherForecast: FC<IWeatherForecastProps> = (props) => {
    const { dataSource, loadOf } = props;
    const timeStamp = new Date(dataSource.date || 0);
    const { data } = useApolloQuery<IGResponse<IForecast[]>>(WEATHER, {
        variables: {
            code_in: [dataSource.symb?.slice(1)]
        }
    })
    const forecasts: IForecast[] = data && data.weather ? data.weather : [];

    return (
        <div className="weather-forecast">
            <section className='date-section'>
                {formatToDate(timeStamp.getTime(), { format: "d l" })}
            </section>
            {
                forecasts.length ?
                    <img
                        className='weather-icon'
                        src={loadOf === "foreca" ?
                            "https://www.foreca.com/public/images/symbols/" + (getSweatIcon(forecasts, dataSource.symb || '').forecastChosen?.icon?.paths[getSweatIcon(forecasts, dataSource.symb || '').indexOfPath])?.split('weather/icon/')[1]
                            : getFilePath(getSweatIcon(forecasts, dataSource.symb || '').forecastChosen?.icon?.paths[getSweatIcon(forecasts, dataSource.symb || '').indexOfPath])}
                        alt="weather icon"
                    /> : ""
            }
            <section className='temperature-section'>
                <h2 className="temperature-max">{dataSource.tmax}</h2>
                <h3 className="temperature-min">{dataSource.tmin}</h3>
            </section>
        </div>
    )

}
